module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-handle@2x.af803dc2.jpg";